import { useCallback } from 'react';

import { PatientNote, PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { Link, LinkSize, RemoveIcon, ShowModalEventInterceptor } from '@dreryk/react-components';

import { notesTranslationKeys } from '../translations';

import { usePatientNoteQuery, usePatientNoteRemoveCommand } from './patientNoteHooks';

type RemoveNoteProps = {
   readonly id: PatientNote['id'];
   readonly patientId: PatientSimple['id'];
};

const RemoveNote = (props: RemoveNoteProps): JSX.Element => {
   const { refetch: refetchNotes } = usePatientNoteQuery(props.patientId);

   const onNoteRemoveSuccess = useCallback(() => {
      refetchNotes();
   }, [refetchNotes]);

   const { executeAsync: removeNote } = usePatientNoteRemoveCommand(onNoteRemoveSuccess);

   const onDeleteIconClick = useCallback(() => {
      removeNote(props.id);
   }, [removeNote, props.id]);

   return (
      <ShowModalEventInterceptor
         testId={'confirmDelete'}
         content={notesTranslationKeys.modal.removeNoteConfirmation}
         title={notesTranslationKeys.modal.removeNote}
         confirmationButtonLabel={notesTranslationKeys.modal.confirmRemoval}
         shouldShowModal
      >
         <Link testId={'deleteNote'} icon={<RemoveIcon />} onClick={onDeleteIconClick} size={LinkSize.SMALL} />
      </ShowModalEventInterceptor>
   );
};

export { RemoveNote };
